import { Operatore } from './../../@core/models/operatore';






import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { AreaVasta, AziendaSanitaria, Comune, Distretto, Provincia, Regione } from '@hm_app/@core/models/anagrafica_geo';
import { Professione, Cittadinanza, TitoloStudio } from '@hm_app/@core/models/dettaglio_profilo';
import { Struttura } from '@hm_app/@core/models/struttura';
import { UserListEntry } from '@hm_app/@core/models/user_listentry';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { ColumnMode, SortType, SelectionType } from '@swimlane/ngx-datatable';
import { NbToastrService } from '@nebular/theme';
import { BaseAuthenticatedComponent } from '@hm_app/shared/base-authenticated/base-authenticated.component';
import { NbRoleProvider } from '@nebular/security';
import { TablePage } from '@hm_app/shared/abstract-list/table_page';
import * as _ from 'lodash';

@Component({
  selector: 'hm-abstract-list',
  templateUrl: './abstract-list.component.html',
  styleUrls: ['./abstract-list.component.scss']
})
export class AbstractListComponent extends BaseAuthenticatedComponent implements OnInit {

  loading = false;

  sorts: string[] = [];

  page = new TablePage();
  rows = new Array<any>();
  selected = [];

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  aziende: AziendaSanitaria[] = [];
  aziende_all: AziendaSanitaria[] = [];
  aree_vaste: AreaVasta[];
  aree_vaste_all: AreaVasta[];
  distretti: Distretto[] = [];
  distretti_all: Distretto[] = [];
  strutture: Struttura[] = [];
  consultori: Struttura[] = [];

  regioni: Regione[] = [];
  province: Provincia[] = [];
  comuni: Comune[] = [];
  professioni: Professione[] = [];
  cittadinanze: Cittadinanza[] = [];
  titoli_studio: TitoloStudio[] = [];

  table_messages = {
    'emptyMessage': 'Nessun Elemento',
    'totalMessage': 'Totale',
    'selectedMessage': 'Selezionati'
  };


  async ngOnInit() {

    await super.ngOnInit();

    await this.prefetch_data();

    this.initFields();

    this.setPage({ offset: 0 });
  }

  async prefetch_data() {
    this.comuni = await this.hm_service.comuniAllPromise();
    this.cittadinanze = await this.hm_service.cittadinanzeAllPromise();
    this.professioni = await this.hm_service.professioniAllPromise();
    this.titoli_studio = await this.hm_service.titoliStudioAllPromise();
    this.regioni = await this.hm_service.regioniAllPromise();
    this.province = await this.hm_service.provinceAllPromise();

    this.strutture = await this.hm_service.struttureAllPromise();
    this.distretti = await this.hm_service.distrettiAllPromise();
    this.distretti_all = _.cloneDeep(this.distretti);
    this.consultori = this.strutture.filter(x => x.tipologia_struttura = 2);
    this.aree_vaste = await this.hm_service.areeVasteAllPromise();
    this.aree_vaste_all = _.cloneDeep(this.aree_vaste);
    this.aziende = await this.hm_service.aziendeAllPromise();
    this.aziende_all = _.cloneDeep(this.aziende);

    if (!(this.isAdmin || this.isMonitor)) {
      this.distretti = [...this.user.capability_rules.can.distretti, ...this.user.capability_rules.controllo.distretti];
      let ids_aziende = _.uniq(_.map(this.distretti, 'azienda_sanitaria'));

      this.aziende = _.filter(this.aziende, (x) => ids_aziende.includes(x.id));
    }

  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getDistretto(distretto: number | Distretto): Distretto {
    if (distretto instanceof Distretto) {
      return distretto;
    }
    return _.find(this.distretti, { id: distretto });
  }

  getComune(comune: number | Comune): Comune {
    if (comune instanceof Comune) {
      return comune;
    }
    return _.find(this.comuni, { id: comune });
  }

  fixed_filters = {
  };
  filters = {};

  constructor(
    protected hm_service: HappyMammaService,
    protected toastrService: NbToastrService,
    protected roleProvider: NbRoleProvider,
  ) {
    super(hm_service, toastrService, roleProvider);
    this.page.pageNumber = 0;
    this.page.size = 20;
  }

  updateFilter() {
    // const val = event.target.value.toLowerCase();
    // this.options.cod_fiscale = val;
    // this.doFetch().then();
  }

  getOptions(): {} {
    let opt = Object.assign({}, this.filters, this.fixed_filters);
    opt = _.pickBy(opt, x => !_.isNil(x));
    return opt;
  }

  async doFetch() {

    this.loading = true;

    let opt = this.getOptions();

    let utenti_resp = await this.hm_service.listUsers(opt, this.page.size, this.page.pageNumber * this.page.size, this.sorts).toPromise();
    this.rows = utenti_resp.utenti;
    this.page.totalElements = utenti_resp.tot;
    this.loading = false;
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  async setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    await this.doFetch();
  }

  onSort(event) {
    // event was triggered, start sort sequence
    console.log('Sort Event', event);
    this.sorts = _.map(event.sorts as SortType[], s => {
      console.log(s);
      return s;
    });
    this.doFetch();
  }

  form = new FormGroup({});
  form_options: FormlyFormOptions = {};
  model: any = {};

  submit() {
    this.doFetch();
  }

  fields: FormlyFieldConfig[];

  initFields() {
    this.fields = []
  }

  @ViewChild('usersTable') table: any;
  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
    console.log('Detail Toggled', event);
  }

  doReset() {
    this.form_options.resetModel();
    this.selected = [];
  }
}
